import { useEffect } from 'react';
const useParseHandoffUrl = (options: {
  onSuccess?: (authToken: string) => void;
  onError?: () => void;
}) => {
  useEffect(() => {
    const parts = window.location.href.split('#');
    if (parts.length <= 1) {
      return;
    }
    try {
      const authToken = decodeURI(parts[1]);
      options.onSuccess?.(authToken);
    } catch {
      options.onError?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
export default useParseHandoffUrl;